export default __webpack_public_path__ + "static/media/upload-file.b192b1bb.svg";